module.exports = __webpack_public_path__ + "static/media/red_nebula_UP.de71f927.png";